<button
  mat-flat-button
  data-cy="download-csv-button"
  class="custom-csv-btn"
  [color]="colorType"
  (click)="dynamicDownloadCsv()">
  {{ buttonLabel }}
</button>
